export default __webpack_public_path__ + "dist/media/Bell.d0a9b578.svg";